<template>
  <section>
    <Loader :visible="loading" />

    <!--Tutorial / -->

    <ModalUploader
        v-bind:display.sync="displayUploder"
        :category="activeCategory"
        :event="eventId"
        :userId="user"
    />

    <ConfirmationModal
        v-bind:display.sync="displayConfirmAlbum"
        :content="confirmationContent"
        saveButton="albums.send"
        v-on:onSave="sendAlbum"
    />

    <PhotoZoom
        :event="event"
        :albumId="albumId"
        :categories="categories"
        :competitor="competitor"
        :zoomPhotos="photos.zoom"
        :photo="photos.current"
        :activeIndex="zoomIndex"
        :active="zoom"
        @closeZoom="closeZoom"
        @setLoader="setLoader" />

    <Carrousel :slides="slides"/>

    <div class="alert alert-primary" role="alert" v-if="event.uploading_photos">
      {{ event.photos_status }}
    </div>

    <div class="container" v-if="visible">
      <div class="event-container"></div>

      <!-- Event info, rekognition and uploader -->
      <div class="row">
        <div class="col-sm-10">
          <h4>{{event.name}}</h4>
          <span>{{event.date | toLongDate}}</span>
        </div>
        <div class="col-sm-1">
          <Rekognition :event="event" @setLoader="setLoader"></Rekognition>
        </div>
        <div class="col-sm-1 add-media" v-if="isUploadCategory">
          <button class="btn-circle" @click="addMedia">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
          <div class="media-options" style="display: none;">
            <div v-if="isUploadImages" class="mb-5" @click="openUploader()">
              <span class="mr-5">{{$t("events.show.addPhotos")}}</span>
              <button class="btn-circle">
                <i class="fa fa-camera" aria-hidden="true"></i>
              </button>
            </div>
            <div v-if="isUploadVideos" @click="openUploader()">
              <span class="mr-5">{{$t("events.show.addVideos")}}</span>
              <button class="btn-circle">
                <i class="fa fa-video-camera" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Competitors search -->
      <div class="row">
        <div class="col-sm-12">
          <EventSearch :eventId="event.identifier" />
        </div>
      </div>

      <!-- Preorder active -->
      <div class="row" v-if="event.active_pre_order">
        <div class="col-sm-12">
          <PreSale :event="event" v-if="loadedComplete"></PreSale>
        </div>
      </div>

      <!-- Buy or send album -->
      <div class="row" v-if="loaded && (!event.active_pre_order && (event.sale || event.generate_album))">
        <div class="col-sm-12" align="right">
          <span v-if="!album.canSend()">
            <span v-if="onlyDownload || onlyCategoriesDownload">
              <button
                  class="primary-btn-light-sm"
                  @click="downloadAlbum()"
                  :title="$t('events.show.downloadAlbum')">
                {{ $t("events.show.downloadAlbum") }}
              </button>
            </span>
            <span v-else>
              <button
                  class="primary-btn-light-sm"
                  @click="addGalleryToCart()"
                  :title="event.price_album | toCurrency">
                {{ $t("events.show.buyAlbum") }}
              </button>
            </span>
            <i class="fa fa-info-circle album-info" :title="event.album_concept"/>
          </span>

          <span v-if="album.canSend()">
            <button
                class="primary-btn-light-sm"
                @click="openConfirmSendAlbum()">
              {{$t("albums.send")}}
            </button>
          </span>
        </div>
      </div>

      <!-- Event albums -->
      <div class="row">
        <div class="col-12" v-show="loaded">
          <EventAlbums
              v-if="showAlbums"
              :visible="displayAlbums"
              :album="album"
              :active="activeAlbum"
              v-on:setAlbum="setAlbum"
          />
        </div>
      </div>

      <!-- Event categories -->
      <div class="row">
        <div class="col-12 pb-0" v-show="loaded">
          <div class="categories-scroll favorites-category">
            <a v-for="category in eventCategories"
               v-bind:key="category.id"
               v-bind:class="{active: category.id == currentCategory}"
               @click="setCategory(category)"
               v-if="category.fixed && category.visible">
              {{category.name}}
              <span>
                ({{category.photos | toNumberFormat}})
              </span>
              <i class="fa fa-cloud-download" @click="downloadFavorites" v-if="category.photos > 0 && category.download"></i>
            </a>
          </div>

          <div class="categories-scroll">
            <a v-for="category in eventCategories"
               v-bind:key="category.id"
               v-bind:class="{active: category.id == currentCategory}"
               @click="setCategory(category)"
               v-if="!category.fixed && category.visible">
              {{ category.name }}
              <span v-if="category.id == currentCategory">
                ({{ category.photos | toNumberFormat }})
              </span>
            </a>
          </div>
        </div>
      </div>

      <div class="row">
        <!--div class="col-12 pt-0" v-if="hasPhotos && !hasVideos"-->
        <div class="col-12 pt-0" v-if="hasPhotos">
          <div class="grid-photos">
            <div id="mosaicGallery" class="justified-gallery">
              <PhotoPreview
                  v-for="photo in photos.actives"
                  :key="photo.id"
                  :event="event"
                  :competitor="competitor"
                  :hasRekognition="categoryRekognition"
                  :isActiveAlbum="canAddToAlbum"
                  :category="{}"
                  :photo="photo"
                  :albumId="albumId"
                  :isAdmin="isAdmin"
                  @setLoader="setLoader">
              </PhotoPreview>
            </div>
            <button class="primary-btn"
                    @click="nextPage()"
                    v-if="hasMorePages">
              {{ $t("events.show.more") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Private event -->
    <div class="container" v-if="!visible && isPrivate">
      <div class="row">
        <div class="col-sm-12">
          <h4 class="restrict mt-80">{{$t("events.show.private")}}</h4>
        </div>
      </div>
    </div>

    <!-- Event access code -->
    <div class="container access-code" v-if="isValidateCode">
      <div class="row">
        <div class="col-sm-12">
          <h4 class=" mt-80">{{$t("events.show.requireCode")}}</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-4">
          <InputForm
              v-model="accessCode"
              :placeholder="$t('events.show.accessCode')"
              v-validate="'required'"
              :name="$t('events.show.accessCode')" />
          <button class="button-cart" @click="sendAccessCode()">{{$t("events.show.validate")}}</button>
        </div>
        <div class="col-sm-4"></div>
      </div>
    </div>

  </section>
</template>

<script>
import $ from "jquery"
import Album from "../../models/Album"
import { mapActions, mapGetters } from "vuex";
import Loader from "../../components/Loader"
import Carrousel from "../../components/Carrousel"
import PageContent from "../../models/PageContent"
import InputForm from "../../components/InputForm"
import PhotoZoom from "../../components/PhotoZoom"
import PhotosMixing from "../../mixins/photos-mixin"
import VideosMixing from "../../mixins/videos-mixin"
import PreSale from "../../components/events/PreSale"
import Select2Form from "../../components/Select2Form"
import EventAlbums from "../../components/EventAlbums"
import EventCategory from "../../models/EventCategory"
import Tutorial from "../../components/events/Tutorial"
import PhotoPreview from "../../components/PhotoPreview"
import Rekognition from "../../components/events/Rekognition"
import EventSearch from "../../components/events/EventSearch"
import ModalUploader from "../../components/events/ModalUploader"
import ConfirmationModal from "../../components/ConfirmationModal"
import AlbumApi from "../../api/AlbumApi";

export default {
  name: "ShowEvent",
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      user: null,
      competitor: null,
      currentCategory: '',
      eventCategories: [],
      categories: [],
      slides: [],
      favoriteCategory: new EventCategory({
        id: 'favorites',
        fixed: true,
        name: this.$t('events.myFavorites'),
        download: true
      }),
      faceCategory: new EventCategory({
        id: 'face_detection',
        visible: false,
        name: this.$t('events.faceDetection'),
      }),
      eventId: '',
      loading: true,
      loadedComplete: false,
      displayUploder: false,
      visible: true,
      event: {},
      isValidateCode: false,
      isPrivate: false,
      accessCode: '',
      showAlbums: false,
      activeAlbum: false,
      album: new Album(),
      albumId: null,
      isAdmin: false,
      displayConfirmAlbum: false,
      confirmationContent: ''
    }
  },
  mixins: [PhotosMixing, VideosMixing],
  components: {
    InputForm,
    EventSearch,
    Rekognition,
    PhotoPreview,
    PhotoZoom,
    Select2Form,
    ModalUploader,
    Tutorial,
    PreSale,
    Carrousel,
    Loader,
    EventAlbums,
    ConfirmationModal
  },
  mounted() {
    this.eventId = this.$route.params.id;
    this.albumId = this.$route.params.album_id;
    this.user = this.currentUser.id;
    this.isAdmin = this.currentUser.is_admin;

    this.$root.$on('setCompetitor', this.fetch);
    this.$root.$on('setLoader', (visible) => { this.loading = visible});
    this.$root.$on('addRekognitionPhotosToAlbum', this.addRekognitionPhotosToAlbum);

    this.getEvent();
  },
  updated() {
    if ($('#container-photos').length > 0) {
      $(this.$el).removeAttr('style')
    }
  },
  computed: {
    ...mapGetters('Event', ['getEventAccess']),
    ...mapGetters('Auth', ['currentUser']),
    ...mapGetters('Preference', ['currentPreference']),

    loaded() {
      return this.categories.length > 0;
    },
    hasMorePages() {
      var active = this.activeCategory;
      return (active && (active.page < active.total_pages));
    },
    categoryParam() {
      var uri = window.location.search.substring(1),
          params = new URLSearchParams(uri);
      return (params.get("category")) ? params.get("category") : null;
    },
    activeCategory() {
      var _this = this;
      if (this.categories) {
        return this.categories.find(function (category) {
          return (category.id == _this.currentCategory);
        });
      } else {
        return null;
      }
    },
    isUploadCategory() {
      return this.isUploadImages || this.isUploadVideos
    },
    isUploadImages() {
      var category = this.activeCategory
      return (category && category.upload_images)
    },
    isUploadVideos() {
      var category = this.activeCategory
      return (category && category.upload_videos)
    },
    categoryRekognition() {
      var category = this.activeCategory
      return (category && this.activeCategory.face_detection)
    },
    competitorNumber() {
      return (this.competitor) ? this.competitor.number : null
    },
    hasFavorites() {
      return (this.hasFavoritesPhotos);
    },
    displayAlbums() {
      return this.event.generate_album;
    },
    canAddToAlbum() {
      return this.event.generate_album;
    },
    onlyDownload() {
      if(this.album.photos.length > 0) {
        return this.album.photos.every((photo) => photo.sponsored );
      }
      return false;
    },
    onlyCategoriesDownload() {
      if(this.categories.length > 0) {
        return this.categories.every((category) => category.sponsored );
      }
      return false;
    },
    async isValidCode() {
      return await this.$validator.validate().then(valid => {
        return valid
      })
    },
  },
  watch: {
    currentCategory(newVal, oldVal) {
      if (newVal != oldVal && newVal != '') {
        if (newVal == this.favoriteCategory.id) {
          this.photos.actives = this.photos.favorites;
          this.videos = this.favoriteVideos;
        } else if (newVal == this.faceCategory.id) {
          this.photos.actives = this.photos.rekognition;
          this.videos = [];
        } else {
          this.photos.actives = this.activeCategory.photos;
          this.videos = this.activeCategory.videos;
        }
        this.activeAlbum = false;
        this.$nextTick(() => { this.renderPhotos() });
      }
    }
  },
  methods: {
    ...mapActions("Event", ["setEventAccess"]),
    ...mapActions('ShoppingCartStore', ['addShoppingCartItem']),

    async downloadFavorites() {
      try {
        this.loading = true
        const url = `/api/v1/events/${this.eventId}/download_album?competitor=${this.competitorNumber}`
        const response = await this.$http.get(url)

        if(response.status == 200 || response.status == 304) {
          location.href = response.data.url
        }
      } catch (e) {
        this.$alertify.error("Error")
      } finally {
        this.loading = false
      }
    },
    async downloadAlbum() {
      try {
        this.loading = true
        const response = await this.$http.get(`/api/v3/albums/${this.albumId}/download`);

        if(response.status == 200 || response.status == 304) {
          location.href = response.data.url
        }
      } catch (e) {
        this.$alertify.error("Error")
      } finally {
        this.loading = false
      }
    },
    async fetch(competitor) {
      this.loading = true;
      this.categories = [];
      this.eventCategories = [];
      this.photos.actives = [];
      this.currentCategory = "";
      this.competitor = competitor;

      await this.fetchImages();
      this.setCategories();
      this.loading = false;
    },
    async getEvent() {
      try {
        const response = await this.$http.get(`/api/v2/events/${this.eventId}`)

        if(response.status == 200 || response.status == 304) {
          this.event = response.data.event
          this.addSlides()
          this.loadedComplete = true
          let display = true

          if(this.event.require_access_code) {
            display = this.validateAccessCode()
          }

          if(display) {
            if(this.event.access) {
              this.$root.$emit('setEvent', this.event)
            } else {
              if(!this.event.active_user) {
                this.$root.$emit('openSignIn')
              }
              this.loading = false
              this.visible = false
              this.isPrivate = true
            }
          }
        }
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async getAssets(competitor) {
      try {
        this.competitor = competitor;

        const response = await this.$http.get(
            `/api/v2/events/${this.eventId}/assets`,
            {
              params: {
                competitor: this.competitorNumber,
                album: this.albumId
              }
            }
        )

        if (response.status == 200 || response.status == 304) {
          return response.data.data
        }
      } catch (e) {
        console.log(e)
        return null
      }
    },
    async addGalleryToCart() {
      const params = { event_id: this.eventId, photo_id: null, album_id: this.albumId };
      this.$alertify.success(this.$t("checkout.addedItem"))
      await this.addShoppingCartItem(params);
      this.$root.$emit("addItemToCart", params)
    },
    async sendAccessCode() {
      let valid = await this.isValidCode

      if(valid) {
        try {
          this.loading = true
          const response = await this.$http.post(
              `/api/v2/events/${this.eventId}/validate_access_code`,
              {access_code: this.accessCode}
          )

          if(response.status == 200 || response.status == 304) {
            if(response.data.access) {
              if(!this.getEventAccess.includes(this.eventId)) {
                this.setEventAccess(this.eventId)
                location.reload()
              }
            } else {
              this.$alertify.error(this.$t("events.show.errors.accessCode"))
            }
          }
        } catch (e) {
          console.log(e)
          return null
        } finally {
          this.loading = false
        }
      }
    },
    async openConfirmSendAlbum() {
      this.loading = true;
      const pageContent = new PageContent();
      const content = await pageContent.show("confirm_send_album");

      this.confirmationContent = new PageContent(content).htmlContent();
      this.displayConfirmAlbum = true;
      this.loading = false;
    },
    async sendAlbum() {
      this.loading = true;

      const album = await AlbumApi.update(this.album.id, {status: 'ready'});
      if(album) {
        this.$alertify.success(this.$t('success'));
      }
      this.loading = false;
    },
    addMedia() {
      if(this.activeCategory.require_login && this.user == null) {
        this.$alertify.error(this.$t("errors.signInFiles"))
        this.$root.$emit('openSignIn')
      } else {
        if($(".media-options").is(":visible")) {
          $(".media-options").hide(500)
        } else {
          $(".media-options").show(500)
        }
      }
    },
    addSlides() {
      let slides = []
      if(this.event.banner_url) {
        slides.push(this.event.banner_url)
      }

      if(this.event.secundary_banner_url) {
        slides.push(this.event.secundary_banner_url)
      }
      this.slides = slides
    },
    nextPage() {
      this.morePhotos(this.activeCategory)
    },
    openUploader() {
      $('.media-options').hide(100)
      this.displayUploder = true
    },
    setCategories() {
      let categories = [this.favoriteCategory, this.faceCategory],
          active = (this.photos.favorites.length > 0) ? this.favoriteCategory.id : null,
          urlCategory = this.categoryParam

      if (urlCategory != null) {
        active = urlCategory;
      }

      for (var i in this.categories) {
        const category = this.categories[i]
        let eventCategory = new EventCategory({
          id: category.id,
          name: category.name
        })
        eventCategory.setPhotos(category.total_photos)
        categories.push(eventCategory)

        if (active == null && category.photos.length > 0) {
          active = category.id
        }
      }

      if (active == null) {
        active = this.favoriteCategory.id;
      }

      this.eventCategories = categories

      this.$nextTick(() => {
        this.currentCategory = active.toString()
      })
    },
    setCategory(category) {
      this.currentCategory = category.id
    },
    setLoader(loading) {
      this.loading = loading
    },
    validateAccessCode() {
      if (this.getEventAccess.includes(this.eventId)) {
        return true
      } else {
        this.loading = false
        this.visible = false
        this.isValidateCode = true
        return false
      }
    },
    setAlbum(album) {
      this.activeAlbum = true;
      this.currentCategory = '';
      this.album = album;
      this.photos.actives = album.photos;
      this.videos = [];

      this.$nextTick(() => {
        this.renderPhotos();
      });
    },
    async fetchImages() {
      const data = await this.getAssets(this.competitor);
      this.categories = data.categories;

      this.photos.favorites = data.favorites.photos;
      this.favoriteCategory.setPhotos(this.photos.favorites.length);

      if(this.displayAlbums && data.album.id) {
        this.showAlbums = true;
        this.album = new Album(data.album);
        this.albumId = data.album.id;
      }
    },
    async addRekognitionPhotosToAlbum(photos) {
      this.loading = true;
      const _this = this;
      const photoIds = photos.map((photo) => photo.id);

      if (photoIds.length > 0) {
        const newPhotos = await AlbumApi.addPhotos(this.album.id, {photo_ids: photoIds});

        newPhotos.forEach((photo) => {
          _this.photos.album.push(photo)
        });
        await this.fetchImages();
      }
      this.loading = false;
    }
  },
}
</script>

<style lang="scss">
@import '../../scss/variables.scss';
@import '../../stylesheets/justifiedGallery.min.css';
@import '../../scss/buttons.scss';

.banner {
  display: block;
  margin-right: auto;
  margin-left: auto;
  max-width: 100%;
  height: auto;
}

.add-media {
  padding-top: 5px !important;

  img {
    cursor: pointer;
    width: 55px;
  }
}

.media-options {
  background-color: #FFF;
  position: absolute;
  z-index: 1000;
  width: 200px;
  right: 27px;
  margin-top: 10px;

  div {
    text-align: right;
    cursor: pointer;
  }
}

div.favorites-category {
  width: 180px;
  float: left;
  overflow: hidden;
}

div.categories-scroll {
  overflow: auto;
  white-space: nowrap;
  scrollbar-width: thin;

  .active {
    border-bottom: 5px solid $secondary-base !important;
  }

  a {
    display: inline-block;
    color: #000;
    text-align: center;
    margin: 10px 20px;
    text-decoration: none;
    cursor: pointer;
    line-height: 48px;

    &:hover {
      @extend .active;
    }
  }

  span {
    color: gray;
  }
}

span.select2-results {
  li {
    font-family: montserrat !important;
  }
}

.album-info {
  font-size: 24px;
  padding-left: 15px;
}

.restrict {
  height: 200px;
  text-align: center;
}

.access-code {
  text-align: center;
  margin-bottom: 150px;
}

.album-information {
  font-size: 14px;
  font-style: italic;
  text-align: justify;

  span {
    font-weight: bold;
  }
}
</style>